import React from "react";
import ReactDOM from "react-dom/client";

// Keep only the fonts needed for the first viewport on the critical path.
import "@fontsource/dm-sans/400.css";
import "@fontsource/manrope/800.css";

// Load secondary weights without delaying the first render.
import("@fontsource/dm-sans/500.css");
import("@fontsource/dm-sans/700.css");
import("@fontsource/manrope/400.css");
import("@fontsource/manrope/500.css");
import("@fontsource/manrope/600.css");
import("@fontsource/manrope/700.css");
import("@fontsource/jetbrains-mono/400.css");
import("@fontsource/jetbrains-mono/500.css");

import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
